/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSystemsRouteImport } from './routes/_app/systems'
import { Route as AppTemplatesRouteImport } from './routes/_app/templates'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'
import { Route as AppMessagesIndexRouteImport } from './routes/_app/messages/index'
import { Route as AppMessagesIdRouteImport } from './routes/_app/messages/$id'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppSettingsGroupsIndexRouteImport } from './routes/_app/settings/groups/index'
import { Route as AppSettingsGroupsIdServicesRouteImport } from './routes/_app/settings/groups/$id.services'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSystemsRoute = AppSystemsRouteImport.update({
  id: '/systems',
  path: '/systems',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesRoute = AppTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMessagesIndexRoute = AppMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesIdRoute = AppMessagesIdRouteImport.update({
  id: '/messages/$id',
  path: '/messages/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIndexRoute = AppSettingsGroupsIndexRouteImport.update({
  id: '/settings/groups/',
  path: '/settings/groups/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIdServicesRoute =
  AppSettingsGroupsIdServicesRouteImport.update({
    id: '/settings/groups/$id/services',
    path: '/settings/groups/$id/services',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/systems': typeof AppSystemsRoute
  '/templates': typeof AppTemplatesRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/messages/$id': typeof AppMessagesIdRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/messages/': typeof AppMessagesIndexRoute
  '/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesByTo {
  '/systems': typeof AppSystemsRoute
  '/templates': typeof AppTemplatesRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/messages/$id': typeof AppMessagesIdRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/messages': typeof AppMessagesIndexRoute
  '/settings/groups': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/systems': typeof AppSystemsRoute
  '/_app/templates': typeof AppTemplatesRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/messages/$id': typeof AppMessagesIdRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/messages/': typeof AppMessagesIndexRoute
  '/_app/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/_app/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/systems'
    | '/templates'
    | '/auth/launch'
    | '/messages/$id'
    | '/settings/users'
    | '/messages/'
    | '/settings/groups/'
    | '/settings/groups/$id/services'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/systems'
    | '/templates'
    | '/auth/launch'
    | '/'
    | '/messages/$id'
    | '/settings/users'
    | '/messages'
    | '/settings/groups'
    | '/settings/groups/$id/services'
  id:
    | '__root__'
    | '/_app'
    | '/_app/systems'
    | '/_app/templates'
    | '/auth/launch'
    | '/_app/'
    | '/_app/messages/$id'
    | '/_app/settings/users'
    | '/_app/messages/'
    | '/_app/settings/groups/'
    | '/_app/settings/groups/$id/services'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/systems': {
      id: '/_app/systems'
      path: '/systems'
      fullPath: '/systems'
      preLoaderRoute: typeof AppSystemsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/templates': {
      id: '/_app/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AppTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/messages/': {
      id: '/_app/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof AppMessagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages/$id': {
      id: '/_app/messages/$id'
      path: '/messages/$id'
      fullPath: '/messages/$id'
      preLoaderRoute: typeof AppMessagesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/': {
      id: '/_app/settings/groups/'
      path: '/settings/groups'
      fullPath: '/settings/groups/'
      preLoaderRoute: typeof AppSettingsGroupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/$id/services': {
      id: '/_app/settings/groups/$id/services'
      path: '/settings/groups/$id/services'
      fullPath: '/settings/groups/$id/services'
      preLoaderRoute: typeof AppSettingsGroupsIdServicesRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppSystemsRoute: typeof AppSystemsRoute
  AppTemplatesRoute: typeof AppTemplatesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppMessagesIdRoute: typeof AppMessagesIdRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppMessagesIndexRoute: typeof AppMessagesIndexRoute
  AppSettingsGroupsIndexRoute: typeof AppSettingsGroupsIndexRoute
  AppSettingsGroupsIdServicesRoute: typeof AppSettingsGroupsIdServicesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSystemsRoute: AppSystemsRoute,
  AppTemplatesRoute: AppTemplatesRoute,
  AppIndexRoute: AppIndexRoute,
  AppMessagesIdRoute: AppMessagesIdRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppMessagesIndexRoute: AppMessagesIndexRoute,
  AppSettingsGroupsIndexRoute: AppSettingsGroupsIndexRoute,
  AppSettingsGroupsIdServicesRoute: AppSettingsGroupsIdServicesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
